import React from "react";
import { Skeleton } from "@mui/lab";

export const ServiceRequestTableSkeleton: React.FC = () => {
    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
            {/* Table Header Skeleton */}
            <div className="bg-gray-50 border-b border-gray-200 px-4 py-3 hidden md:block">
                <div className="flex items-center gap-4">
                    <Skeleton variant="text" width={120} height={20} />
                    <Skeleton variant="text" width={100} height={20} />
                    <Skeleton variant="text" width={150} height={20} />
                    <Skeleton variant="text" width={200} height={20} className="flex-1" />
                    <Skeleton variant="text" width={150} height={20} />
                    <Skeleton variant="text" width={120} height={20} />
                    <Skeleton variant="text" width={100} height={20} />
                    <Skeleton variant="text" width={100} height={20} />
                </div>
            </div>

            {/* Table Rows Skeleton */}
            <div className="divide-y divide-gray-100">
                {Array.from({ length: 8 }, (_, i) => (
                    <div key={i} className="px-4 py-4 hover:bg-gray-50 transition-colors">
                        <div className="flex items-center gap-2 md:gap-4 flex-wrap md:flex-nowrap">
                            {/* Status */}
                            <div className="w-full md:w-auto">
                                <Skeleton variant="rectangular" width={100} height={24} className="rounded-full" />
                            </div>

                            {/* Tracking ID */}
                            <div className="w-full md:w-auto">
                                <Skeleton variant="text" width={100} height={18} />
                            </div>

                            {/* Name */}
                            <div className="flex-1 min-w-[150px] space-y-1">
                                <Skeleton variant="text" width="80%" height={18} />
                                <Skeleton variant="text" width="60%" height={14} />
                            </div>

                            {/* Request Type */}
                            <div className="w-full md:w-auto md:flex-1">
                                <Skeleton variant="text" width="90%" height={18} />
                            </div>

                            {/* Assignee */}
                            <div className="hidden md:flex items-center gap-2">
                                <Skeleton variant="circular" width={20} height={20} />
                                <Skeleton variant="text" width={100} height={18} />
                            </div>

                            {/* Assigned By */}
                            <div className="hidden md:block">
                                <Skeleton variant="text" width={100} height={18} />
                            </div>

                            {/* Date */}
                            <div className="hidden md:block space-y-1">
                                <Skeleton variant="text" width={80} height={16} />
                                <Skeleton variant="text" width={60} height={14} />
                            </div>

                            {/* Actions */}
                            <div className="flex gap-2 ml-auto">
                                <Skeleton variant="circular" width={32} height={32} />
                                <Skeleton variant="circular" width={32} height={32} />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

